"use client";

import Home from "@/components/Home";
import { useContestSearch } from "@/hooks/contest/useContestSearch";
import { useEffect } from "react";

export default function Component() {
  const { items: contests, isLoading: contestLoading } = useContestSearch({ isPublished: true, screen: "public" });
  // リサイズイベントを発火して画面のレイアウトを調整
  useEffect(() => {
    setTimeout(() => {
      if (window !== undefined) {
        window.dispatchEvent(new Event("resize"));
      }
    }, 100);
  }, []);

  if (contestLoading) {
    return;
  }

  return (
    <div>
      <Home
        contests={contests}
      />
    </div>
  );
}
